<template>
  <div id="" class="help">
    <call />
    <!-- header -->
    <top-bar title="ヘルプ" backUrl="/help/mobileorder"/>
    <!-- main -->
    <main>
      <footer-app page="top" :loading="loading"></footer-app>
      <section>
        <div class="l-main--bg-border l-main--bg-border--pink">
          <div class="l-main__body">
            <div class="l-check-cart">
              <div class="l-check-cart__head pb-50">
                <div class="l-check-cart__title text-left">再注文方法</div>
                <div class="help-card mb-51">
                  <div class="l-check-cart__title text-left">再注文する</div>
                  <div class="detail-wrap">
                    <p class="l-check-cart__title text-left">1.注文状況・履歴ボタンをタップ</p>
                    <p class="">
                      モバイルオーダーTOP画面の「注文状況・履歴ボタン」をタップします。
                    </p>
                    <img class="border" src="/assets/images/help/help-mobileorder-reorder-1.png" alt="">
                  </div>
                  <div class="detail-wrap">
                    <p class="l-check-cart__title text-left">2.注文をタップ</p>
                    <p>注文一覧から、再注文したい注文をタップします。</p>
                    <img src="/assets/images/help-mobileorder-reorder-2.png" alt="">
                  </div>
                  <div class="detail-wrap">
                    <p class="l-check-cart__title text-left">3.再度カートに追加するボタンをタップ</p>
                    <p>注文詳細の下部にある「再度カートに追加する」ボタンをタップします。</p>
                    <img class="mb-0" src="/assets/images/help-mobileorder-reorder-3.png" alt="">
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>
      <button-back />
    </main>
  </div>
</template>

<script>
import "core-js/stable";
import "regenerator-runtime/runtime";
import Vue from "vue";
import { Common } from "../common/common.js";
import { Tenant } from "../plugin/mixin.js";
import TopBar from "../components/TopBar.vue";
import Footer from "../components/Footer.vue";
import ButtonBack from "../components/ButtonBack.vue";

export default Vue.extend({
  name: "HelpMobileorderReorder",
  components: {
    TopBar,
    FooterApp: Footer,
    ButtonBack,
  },
  mixins: [Tenant],
  data() {
    return {
      loading: false,

    };
  },
  created() {
    this.init();
  },
  mounted() {
    Common.initDom();
  },
  methods: {
    async init() {
      Common.vueInitFunc(this);
      this.loading = false;
    },
  },
});
</script>